import { FileUpload, SysFiles, ClientFiles } from "../../../components";

function Index({ loan }) {

    return (
        <div className="space-y-5 py-4">
            {(loan?.state !== "active" && loan?.state !== "completed") && (
                <FileUpload loan={loan} />
            )}
            <SysFiles loan={loan} />
            <ClientFiles name="Loan" loan={loan} />
            <ClientFiles name="Client" loan={loan} />
        </div>
    );
}

export default Index;
